import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

import Layout from "./components/Layout";
import Login from "./pages/Login";
import DancerLogin from "./pages/DancerLogin";
import Dashboard from "./pages/Dashboard";
import Dancers from "./pages/Dancers";
import DancerDetail from "./pages/DancerDetail";
import Accounts from "./pages/Accounts";
import DailyCash from "./pages/DailyCash";
import PaymentRequests from "./pages/PaymentRequests";
import Payments from "./pages/Payments";
import Staff from "./pages/Staff";
import Timesheets from "./pages/Timesheets";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import DancerPortal from "./pages/DancerPortal";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#a1a1aa]">
        Chargement...
      </div>
    );
  if (!user) {
    const target = roles && roles.length === 1 && roles[0] === "dancer" ? "/danseuse/login" : "/login";
    return <Navigate to={target} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "dancer" ? "/portail" : "/dashboard"} replace />;
  }
  return children;
}

function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "dancer" ? "/portail" : "/dashboard"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/danseuse/login" element={<DancerLogin />} />
          <Route path="/danseuses/login" element={<DancerLogin />} />
          <Route path="/" element={<RoleRedirect />} />

          {/* Staff / management */}
          <Route
            element={
              <Protected roles={["admin", "manager"]}>
                <Layout />
              </Protected>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dancers" element={<Dancers />} />
            <Route path="/dancers/:id" element={<DancerDetail />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/daily-cash" element={<DailyCash />} />
            <Route path="/payment-requests" element={<PaymentRequests />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/timesheets" element={<Timesheets />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Dancer portal */}
          <Route
            element={
              <Protected roles={["dancer"]}>
                <Layout />
              </Protected>
            }
          >
            <Route path="/portail" element={<DancerPortal />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
